import * as React from "react"

function FilterCross(props) {
  return (
    <svg
      width={14}
      height={14}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.237 6.992h11.984M1.237 6.992h11.984M7.245 13V1.015M7.245 13V1.015"
        stroke="#0C1414"
        strokeLinecap="square"
      />
    </svg>
  )
}

export default FilterCross
